import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CreatePortalSessionResponse {
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  private http = inject(HttpClient);
  private apiUrl = environment.api_host;

  /**
   * Calls the backend to create a Stripe Customer Portal session.
   * @returns An observable containing the secure URL for the portal.
   */
  createCustomerPortalSession(): Observable<CreatePortalSessionResponse> {
    const endpoint = `${this.apiUrl}/billing/create-customer-portal-session`;
    return this.http.post<CreatePortalSessionResponse>(endpoint, {});
  }
}
